import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { competitionBunja } from '../bunja';
import { RegisterNowButton as NewRegisterNowButton } from './new';
import { RegisterNowButton as OldRegisterNowButton } from './old';

export const RegisterNowButton = () => {
  const { competitionAtom, isNewDesignTargetAtom } = useBunja(competitionBunja);
  const competition = useAtomValue(competitionAtom);
  const isNewDesignTarget = useAtomValue(isNewDesignTargetAtom);
  if (!competition) return null;
  if (isNewDesignTarget) return <NewRegisterNowButton />;
  return <OldRegisterNowButton />;
};
